import { imagePath } from '../../../../utils/imagePath';
import AugmentedRealityData from './AgumentedRealityData';
import AnalyticsData from './AnalyticsData';
import ArTechnologyData from './ArTechnologyData';
import GettingStartedData from './GettingStartedData';
import IntroductionData from './IntroductionData';
import MrTecnologyData from './MrTechnologyData';
import VrTechnologyData from './VrTechnologyData';

export const documentationData = [
  IntroductionData,
  GettingStartedData,
  ArTechnologyData,
  VrTechnologyData,
  MrTecnologyData,
  AugmentedRealityData,
  AnalyticsData,
];
